import { render } from "./ImprimirEtiquetaUbicacionPage.vue?vue&type=template&id=5934656c&scoped=true"
import script from "./ImprimirEtiquetaUbicacionPage.vue?vue&type=script&lang=js"
export * from "./ImprimirEtiquetaUbicacionPage.vue?vue&type=script&lang=js"

import "./ImprimirEtiquetaUbicacionPage.vue?vue&type=style&index=0&id=5934656c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\eric.aparicio\\Documents\\REPOS\\ubiku.2023-master\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5934656c"]])

export default __exports__